import React from 'react';
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {loadCasinoGames, selectCategory, selectCategoryName} from "../CasinoActions";
import CasinoGames from "./CasinoGames";
import {AppState} from "../../RootReducer";
import {fetchSettings} from "../../settings/SettingsActions";
import {CasinoLobby, CasinoLobbyCategory, Settings} from "../../http/protocol";
import  "./styles/CasinoCategoryPage.scss";
import {RouteComponentProps} from "react-router-dom";


interface Props extends RouteComponentProps<{ name?: string, catId : string}>  {
    loadCasinoGames? : () => void,
    settings : Settings,
    fetchSettings : typeof fetchSettings,
    selectedCategory?: number;
    categories? : CasinoLobbyCategory[],
    selectCategory? : (cat : number) => void;
    selectCategoryName? : (catName : string) => void;
    lobby?: CasinoLobby;
    selectedCategoryName?:string;

};

export class CasinoCategoryPage extends React.Component<Props>{
    constructor(props : Props){
        super(props);
    }
    componentDidMount(): void {
        if(this.props.lobby == null) {
            this.props.loadCasinoGames && this.props.loadCasinoGames();
        }

        if(this.props.settings == undefined) {
            this.props.fetchSettings();
        }

        this.checkParam();
    }

    checkParam = () => {
        let catId = this.props.match.params.catId;
        let catName = this.props.match.params.name;
        // console.error(catName);
        if(catId) {
            if(Number(catId)) {
                this.props.selectCategory && this.props.selectCategory(Number(catId));
            }
        }
        if(catName) {
            this.props.selectCategoryName && this.props.selectCategoryName(catName);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        if (this.props.lobby !== prevProps.lobby) {
            if(this.props.lobby) {
                this.checkParam();
            }
        }
    }





    handleGoBack = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className={"category-page-container"}>
                <CasinoGames />
            </div>

        )
    }
}

const stateToProps = (state : AppState) => {
    return {
        settings: state.settings.settings ? state.settings.settings : {},
        selectedCategory : state.casino.selectedCategory,
        categories : state.casino.lobby ? state.casino.lobby.categories : [],
        lobby: state.casino.lobby,
        selectedCategoryName:state.casino.selectedCategoryName
    }
};

const dispatchToProps = (dispatch : Dispatch) => (
    {
        loadCasinoGames : ()=> dispatch(loadCasinoGames() as any),
        fetchSettings : () => dispatch(fetchSettings() as any),
        selectCategory : (cat : number) => dispatch(selectCategory(cat)),

        selectCategoryName: (catName: string) => dispatch(selectCategoryName(catName)),
    }
);

export default connect(stateToProps, dispatchToProps)(CasinoCategoryPage)

